import { cssProps } from '@/theme/theme';
import { cssPropVar } from '@/theme/utils';
import { css, keyframes } from '@emotion/react';
import { VisuallyHidden } from 'react-aria';

const barKeyframes = keyframes`
	0% { right: 100%;left: 0%; }
	50% { right: 0%;left: 0%; }
	100% { right: 0%;left: 100%; }
`;

const LoadingScreen = () => {
	return (
		<div
			css={css`
				position: fixed;
				left: 0;
				top: 0;
				width: 100%;
				height: 100%;
				background: ${cssPropVar(cssProps.color.loadingBackground)};
				margin: 0;
				padding: 0;
				z-index: ${cssPropVar(cssProps.zIndex.loadingScreen)};
			`}
			aria-busy="true"
			aria-live="polite"
		>
			<VisuallyHidden>Loading...</VisuallyHidden>
			<div
				css={css`
					position: absolute;
					left: 0;
					right: 0;
					height: 4px;
					bottom: 0;
					background: ${cssPropVar(cssProps.color.primary)};
					animation: ${barKeyframes} 1000ms linear;
					animation-iteration-count: infinite;
				`}
			/>
		</div>
	);
};

export default LoadingScreen;
